import { Spinner } from '@flipster/react/design-system/spinner';
import { Styles, css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

interface Props {
  css?: Styles;
}

export const LoadingPage = ({ css: cssProps }: Props) => {
  return (
    <main className={css(center.raw({ h: 'minHeightWithoutNavigation', w: '100%' }), cssProps)}>
      <Spinner size={40} />
    </main>
  );
};
